import generarReportePDF from '../utils/pdfGenerator';
import api from './api';

export const pdfService = {
  /**
   * Generar y descargar PDF de reporte de examen individual
   * @param {Object} usuario - Datos del usuario desde la tabla de resultados
   * @param {Object} resultado - Resultado del examen (de getResultadoFinalExamen)
   */
  descargarReportePDF: async (usuario, resultado) => {
    try {
      // 1. Obtener datos completos del usuario desde API
      let datosUsuarioCompletos = {};
      try {
        const responseUsuario = await api.get(`/usuarios/${resultado.usuarioId || usuario.usuarioId}`);
        datosUsuarioCompletos = responseUsuario.data;
      } catch (error) {
        console.warn('No se pudo obtener datos completos del usuario:', error);
      }

      // 2. Obtener fechas de inicio y fin desde API de respuestas
      let fechaInicio = 'N/A';
      let fechaFin = 'N/A';
      let duracion = 'N/A';
      
      try {
        const responseRespuestas = await api.get(`/respuestas/usuario/${resultado.usuarioId || usuario.usuarioId}`);
        const respuestas = responseRespuestas.data;
        
        if (respuestas && respuestas.length > 0) {
          // Obtener primera y última respuesta del examen específico
          const respuestasExamen = respuestas.filter(r => r.examenId === resultado.examenId);
          
          if (respuestasExamen.length > 0) {
            // Ordenar por fecha
            respuestasExamen.sort((a, b) => new Date(a.fechaRespuesta) - new Date(b.fechaRespuesta));
            
            const primeraRespuesta = respuestasExamen[0];
            const ultimaRespuesta = respuestasExamen[respuestasExamen.length - 1];
            
            fechaInicio = new Date(primeraRespuesta.fechaRespuesta).toLocaleString('es-PE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });
            
            fechaFin = new Date(ultimaRespuesta.fechaRespuesta).toLocaleString('es-PE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });
            
            // Calcular duración
            const diff = new Date(ultimaRespuesta.fechaRespuesta) - new Date(primeraRespuesta.fechaRespuesta);
            const minutos = Math.floor(diff / 60000);
            const segundos = Math.floor((diff % 60000) / 1000);
            duracion = `${minutos} min ${segundos} seg`;
          }
        }
      } catch (error) {
        console.warn('No se pudo obtener fechas de respuestas:', error);
      }

      // 3. Obtener información del examen y proceso desde perfiles
      let nombreExamen = resultado.examenNombre || 'N/A';
      let proceso = 'N/A';
      
      try {
        // Primero obtener datos del examen para saber el perfilId
        const responseExamen = await api.get(`/examenes/${resultado.examenId}`);
        const examenData = responseExamen.data;
        nombreExamen = examenData.nombre || nombreExamen;
        
        // Luego obtener el perfil completo para acceder a los procesos
        if (examenData.perfilId) {
          const responsePerfiles = await api.get('/perfiles');
          const perfiles = responsePerfiles.data;
          
          // Buscar el perfil correspondiente
          const perfilActual = perfiles.find(p => p.id === examenData.perfilId);
          
          if (perfilActual) {
            // El proceso es el nombre del perfil + procesos
            if (perfilActual.procesos && perfilActual.procesos.length > 0) {
              const nombresProcesos = perfilActual.procesos.map(p => p.nombre).join(', ');
              proceso = `${perfilActual.nombre} - ${nombresProcesos}`;
            } else {
              proceso = perfilActual.nombre;
            }
          }
        }
      } catch (error) {
        console.warn('No se pudo obtener datos del examen/proceso:', error);
      }

      // 4. Preparar datos del usuario para el PDF
      const nombre = datosUsuarioCompletos.name && datosUsuarioCompletos.lastname 
        ? `${datosUsuarioCompletos.name} ${datosUsuarioCompletos.lastname}`
        : resultado.usuarioNombre || usuario.usuarioNombre || 'N/A';

      const datosUsuario = {
        nombre: nombre,
        dni: datosUsuarioCompletos.dni || 'N/A',
        proceso: proceso,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
        duracion: duracion
      };

      // 5. Preparar datos del examen
      const datosExamen = {
        nombre: nombreExamen,
        descripcion: 'Evaluación de habilidades cognitivas'
      };

      // 6. Generar el PDF
      await generarReportePDF(datosUsuario, datosExamen, resultado);
      
      return true;
    } catch (error) {
      console.error('Error al generar PDF:', error);
      throw error;
    }
  }
};

export default pdfService;
